import {StyleParamType, createStylesParams} from '@wix/tpa-settings'

import {Alignment, ImageSize} from '../../../../../types/createStylesParams'

export type LayoutStylesParams = {
  spaceBetweenExperiences: StyleParamType.Number
  maximumExperiencesPerRow: StyleParamType.Number
  breadcrumbsAlignment: StyleParamType.Number
  titleAlignment: StyleParamType.Number
  experienceTextAlignment: StyleParamType.Number
  experienceButtonAlignment: StyleParamType.Number
  fitLocationTabsWidthToListWidth: StyleParamType.Number
  locationTabsAlignment: StyleParamType.Number
  experienceImageSize: StyleParamType.Number
}

export const layoutStylesParams = createStylesParams<LayoutStylesParams>({
  spaceBetweenExperiences: {
    type: StyleParamType.Number,
    getDefaultValue: (params) => (params.isMobile ? 20 : 32),
  },
  maximumExperiencesPerRow: {
    type: StyleParamType.Number,
    getDefaultValue: (params) => (params.isMobile ? 1 : 3),
  },
  breadcrumbsAlignment: {
    type: StyleParamType.Number,
    getDefaultValue: () => Alignment.Left,
  },
  titleAlignment: {
    type: StyleParamType.Number,
    getDefaultValue: () => Alignment.Center,
  },
  experienceTextAlignment: {
    type: StyleParamType.Number,
    getDefaultValue: () => Alignment.Center,
  },
  experienceButtonAlignment: {
    type: StyleParamType.Number,
    getDefaultValue: () => Alignment.Center,
  },
  fitLocationTabsWidthToListWidth: {
    type: StyleParamType.Number,
    getDefaultValue: (params) => (params.isMobile ? 1 : 0),
  },
  locationTabsAlignment: {
    type: StyleParamType.Number,
    getDefaultValue: () => Alignment.Center,
  },
  experienceImageSize: {
    type: StyleParamType.Number,
    getDefaultValue: () => ImageSize.Crop,
  },
})
